import {Form, Input, InputNumber, Modal} from "antd";
import {useEffect} from "react";
import {FormModalProps} from "../../../utils/useFormModal";
import * as api from "../../../apis/salesOrder"
import {useRequest} from "ahooks";


interface SendOAPeriodModalProps extends FormModalProps {
    orderId: number
}

export default function SendOAPeriodModal(props: SendOAPeriodModalProps) {

    const {orderId, form, ...otherProps} = props;

    const {run} = useRequest(api.specialApprovalConfirm, {
        manual: true,
        onSuccess: (res) => {
            form.setFieldsValue(res.data.data)
        }
    })

    useEffect(() => {
        if (orderId && props.open) {
            run(orderId)
        }
    }, [props.open]);

    return <Modal {...otherProps} title={'特批确认'} destroyOnClose>
        <Form layout={"vertical"} form={form}>
            <Form.Item name={'orderId'} noStyle/>
            <Form.Item name={'historyArrears'} label={'历史欠款'}>
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name={'overPeriodArrears'} label={'超账期欠款'}>
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name={'earliestArrearsShouldReceiptDate'} label={'最早欠款应回款日期'}>
                <Input disabled={true}/>
            </Form.Item>
            <Form.Item name={'promisePaybackAmount'} label={'承诺回款金额'}
                       rules={[{required: true, message: '此项必填'}]}>
                <InputNumber/>
            </Form.Item>
            <Form.Item name={'paymentProtectionRemark'} label={'付款保障措施简述'}
                       rules={[{required: true, message: '此项必填'}]}>
                <Input/>
            </Form.Item>
        </Form>
    </Modal>
}